export default function TrustSection() {
  const marketplaces = [
    { name: "Amazon", icon: "ri-amazon-line", color: "text-amber-600" },
    { name: "Mercado Livre", icon: "ri-store-2-line", color: "text-yellow-500" },
    { name: "Shopee", icon: "ri-shopping-bag-line", color: "text-orange-500" },
    { name: "Magazine Luiza", icon: "ri-building-2-line", color: "text-blue-500" },
    { name: "Americanas", icon: "ri-gift-line", color: "text-red-500" },
    { name: "Casas Bahia", icon: "ri-home-2-line", color: "text-blue-600" },
  ];

  return (
    <section className="py-10 border-y border-gray-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-center gap-6 md:gap-10">
          <p className="text-gray-400 text-sm font-semibold whitespace-nowrap">
            Monitoramos preços em:
          </p>
          <div className="flex flex-wrap items-center justify-center md:justify-start gap-6">
            {marketplaces.map((m) => (
              <div key={m.name} className="flex items-center gap-2 text-gray-500 hover:text-gray-700 transition-colors">
                <i className={`${m.icon} ${m.color} text-xl`}></i>
                <span className="text-sm font-semibold">{m.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
